import { render, staticRenderFns } from "./technocracyEdit.vue?vue&type=template&id=75c6fb0a"
import script from "./technocracyEdit.vue?vue&type=script&lang=js"
export * from "./technocracyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c6fb0a')) {
      api.createRecord('75c6fb0a', component.options)
    } else {
      api.reload('75c6fb0a', component.options)
    }
    module.hot.accept("./technocracyEdit.vue?vue&type=template&id=75c6fb0a", function () {
      api.rerender('75c6fb0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/technocracy/technocracyEdit.vue"
export default component.exports